import { MakeInlineWCCContentBlock } from 'components/content/mixins/inline';
import { DOMHelpers } from 'helpers/dom';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { WCCContentBlock } from '../block/block';
import { WCCContentBlockConfig } from '../block/block.interfaces';

export interface WCCContentEmailBlockConfig extends WCCContentBlockConfig {
    email: SubscribableOrNullableValue<string>
}

const ExtendedWCCContentBlock = [
    MakeInlineWCCContentBlock
].reduce((result, mixin) => mixin(result), WCCContentBlock);

export class WCCContentEmailBlock extends ExtendedWCCContentBlock {
    private url: Subscribable<string | undefined>

    email: Subscribable<string | undefined>

    constructor(config: WCCContentEmailBlockConfig) {
        super(config);

        this.email = ko.flattenComputed(config.email);
        this.url = this.email.pluck(email => `mailto:${email}`);
    }

    protected override getNodes() {
        return DOMHelpers.createBindedNodes(`<a target="_blank" data-bind="attr: { href: url }, text: title"></a>`, { url: this.url, title: this.content });
    }
}

